import {useTranslation} from "react-i18next";
import {Box} from "@mui/system";
import {Card, CardContent, Grid, TextField, Typography} from "@mui/material";
import dayjs from "dayjs";
import * as React from "react";

const CustomerRADetails = (props: any) => {
    const {t} = useTranslation("finance", {keyPrefix: "payments.payment-request"});
    const customerRADetails = props.customerRADetails;

    return (
        <Box>
            <Card variant="outlined" sx={{margin: '16px'}}>
                <CardContent>
                    <Grid container direction={'row'} rowGap={5}>
                        <Grid container item spacing={2} alignItems={'center'}>
                            <Grid item xs={12}>
                                <Typography variant={'body2'} color={'primary.light'} fontWeight={700}
                                            textTransform={'uppercase'}>
                                    {t('pages.wizard.form.title-raOwner')}
                                </Typography>
                            </Grid>

                        </Grid>
                        <Grid container item spacing={2} alignItems={'center'}>


                            <Grid item md={3} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails.firstName}
                                    label={t("pages.wizard.form.labelRAOwnerName")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails.lastName}
                                    label={t("pages.wizard.form.labelRAOwnerLastName")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails.companyName}
                                    label={t("pages.wizard.form.labelRAOwnerBusinessName")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails?.taxCode ? customerRADetails.taxCode : customerRADetails?.vatCode ? customerRADetails.vatCode : ""}
                                    label={t("pages.wizard.form.labelRAOwnerFiscalCode")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>

                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails?.siren ? customerRADetails.siren : ""}
                                    label={t("pages.wizard.form.labelRAOwnerSiren")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails?.siret ? customerRADetails.siret : ""}
                                    label={t("pages.wizard.form.labelRAOwnerSiret")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails.address}
                                    label={t("pages.wizard.form.labelRAOwnerAddress")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>

                            <Grid item md={3} sm={12} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails.email}
                                    label={t("pages.wizard.form.labelRAOwnerEmail")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={12} xs={12}>
                                <TextField
                                    label={t("pages.wizard.form.labelRAOwnerBirthDate")}
                                    value={customerRADetails?.birthDate ? dayjs(customerRADetails.birthDate).format("L") : ""}
                                    fullWidth
                                    disabled={true}
                                    id="birthDate"
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails.birthCity}
                                    label={t("pages.wizard.form.labelRAOwnerBirthPlace")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails.birthProvince}
                                    label={t("pages.wizard.form.labelRAOwnerBirthProvince")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <TextField
                                    fullWidth
                                    disabled={true}
                                    value={customerRADetails.birthCountry}
                                    label={t("pages.wizard.form.labelRAOwnerNationality")}
                                    type="text"
                                    InputLabelProps={{shrink: true}}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    )


}

export default CustomerRADetails;